<template>
	<div class="block-area">
		<ui-stage-status-config />
	</div>
</template>
<script>
	import { uiStageStatusConfig } from '@/components/ui-facilita/funnel'

	export default {
		name: 'configuration-stage-status',

		components: {
			uiStageStatusConfig,
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
